'use strict';

angular.module('shiftTraderApp')
  .controller('CreateMultiUserDialogCtrl', function ($scope, $uibModalInstance, org, allPositions, Users,
                                                     $timeout, SAErrorHandler, regexStrings) {

    $scope.regexStrings = regexStrings;
    $scope.showForm = false;

    $scope.close = function() {
      if ($scope.allAddedUsers.length > 0) {
        $uibModalInstance.close($scope.allAddedUsers);
      } else {
        $uibModalInstance.dismiss();
      }
    };

    $scope.allPositions = _.map(allPositions, function(pos) {
      if (_.isNull(pos.department)) {
        pos.department = {
          name: 'Uncategorized'
        };
      }
      return pos;
    });

    $scope.done = function() {
      console.log($scope.allAddedUsers);
      $uibModalInstance.close($scope.allAddedUsers);
    };

    $scope.userFormData = {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber:'',
      baseRate: org.organization_config.starting_pay_rate,
      externalId: ''
    };

    $scope.showExternalId = org.organization_config.external_id_integration_enabled
    $scope.showForm = true;

    $scope.allAddedUsers = [];

    $scope.createUser = function() {
      var data = {
        user: {
          first_name: $scope.userFormData.firstName,
          last_name: $scope.userFormData.lastName,
          email: $scope.userFormData.email,
          phone_number: $scope.userFormData.phoneNumber
        },
        membership: {
          organization_id: org.id,
          external_id: $scope.userFormData.externalId,
          role:'employee',
          active: true
        },
        position: {
          id: $scope.userFormData.positionId
        },
        users_position: {
          // hourly_wage: $scope.userFormData.positionHourlyWage,
          // training_hourly_wage: $scope.userFormData.positionTrainingHourlyWage,
          training: $scope.userFormData.positionTraining
        },
        pay_rate: $scope.userFormData.baseRate
      };

      Users.create(data)
        .then(function(user) {
          console.log('yay! user create went through');
          console.log(user);
          user._created = true;
          $scope.allAddedUsers.push(new Users.initWithData(user));
          $scope.userFormData.firstName = '';
          $scope.userFormData.lastName = '';
          $scope.userFormData.positionId = undefined;
          $scope.userFormData.baseRate = org.organization_config.starting_pay_rate;
          $scope.userFormData.email = '';
          $scope.userFormData.phoneNumber = '';
          $scope.userFormData.positionTraining = true;
          $scope.userFormData.externalId = '';
          $scope.showForm = false;

          $timeout(function() {
            $scope.showForm = true;
          }, 100);

        }, function(response) {
          console.log('boo! we had a problem');
          console.log(response);
          SAErrorHandler.processError(response);
        });
    };

  });
